import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_monitoring_contracted_personnel_facility_ensure_they_perform'

export const dataPointDefinition = {
  retracedId: 'no_monitoring_contracted_personnel_facility_ensure_they_perform',
  name: 'No monitoring of contracted personnel by the facility to ensure they perform work in a safe and legal manner',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-con-5x',
      number: 'HS-CON-2-3',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-con-2',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-54,Yes',
      machineShowHide: '[2],hs-54,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-con-5x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30540,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
